import React from "react";
import { Pressable, StyleSheet, Text, View } from "react-native";

import { themes } from "../Styling/themeConfigs";

import { type Tag } from "@/schemas/components/Tag";

interface TagItemProps {
  tag: Tag;
  isSelected: boolean;
  onPress: (tagId: string) => void;
}

function TagItem({
  tag,
  isSelected,
  onPress,
}: TagItemProps): React.JSX.Element {
  const currentTheme = themes.morning;

  const styles = StyleSheet.create({
    tag: {
      borderRadius: 50, // Full round corners for pill shape
      marginBottom: 8,
      marginRight: 8,
      paddingHorizontal: 16, // Increased padding for better touch target
      paddingVertical: 8,
      shadowColor: "#000",
    },
    tagText: {
      color: "#FFFFFF",
      fontSize: 12,
      fontWeight: "600",
    },
    activeTag: {
      backgroundColor: "#01579b", // gray-600 equivalent
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
      elevation: 5,
    },
    activeTagText: {
      color: "#FFFFFF",
      fontWeight: "700", // bold
    },
    inactiveTagText: {
      color: currentTheme.typography.h2.color,
    },
    inactiveTag: {
      backgroundColor: "#FFFFFF",
      borderWidth: 1,
    },
  });

  return (
    <Pressable onPress={() => onPress(tag.id)}>
      <View
        style={[styles.tag, isSelected ? styles.activeTag : styles.inactiveTag]}
      >
        <Text
          style={[
            styles.tagText,
            isSelected ? styles.activeTagText : styles.inactiveTagText,
          ]}
        >
          #{tag.label}
        </Text>
      </View>
    </Pressable>
  );
}

export default TagItem;
